import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { CategoryService } from '../../../../../admin/src/app/services/category.service';
import { ProductService } from '../../../../../admin/src/app/services/product.service';
import { Pagination } from '../../../../../admin/src/app/models/pagination';
import { Category } from '../../../../../admin/src/app/models/category';
import { Product } from '../../../../../admin/src/app/models/product';
import { LanguageService } from '../../services/language.service';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit, OnDestroy {

  categories: Category[] = [];

  products: Product[] = [];

  categoryProducts = {};

  pagination: Pagination = <Pagination>{ elementsPerPage: 1000, page: 0, sort: 'index' };

  categoryId: string;

  category: Category;

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private categorySvc: CategoryService,
    private productSvc: ProductService,
    public language: LanguageService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Catetory');

    this.sub = this.route.paramMap.subscribe(params => {
      this.categoryId = params.get('id');
      this.getCategories().subscribe(() => this.getProducts());
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getCategories() {
    return new Observable(observer => {
      this.categories = [];
      this.categorySvc.getAll(this.pagination).subscribe(data => {
        let categories = data.payload.elements;
        categories.forEach(c => {
          if (!!c.parentCategory && c.parentCategory.id === this.categoryId) {
            this.categories.push(c);
          } else if (c.id === this.categoryId) {
            this.category = c;
            this.categories.push(c);
          }
        });
        observer.next();
        observer.complete();
      });
    });
  }

  getProducts() {
    this.products = [];
    this.productSvc.getAll(this.pagination).subscribe(data => {
      let products = data.payload.elements;
      products.forEach(p => {
        if (p.category.id === this.categoryId || !!this.categories.find(c => c.id === p.category.id)) {
          this.products.push(p);
          let category = this.categories.find(c => c.id === p.category.id);
          if (!this.categoryProducts[category.id]) {
            this.categoryProducts[category.id] = [];
          }
          this.categoryProducts[category.id].push(p);
        }
      });
    });
  }

  loadProduct(product: Product) {
    this.router.navigate([product.id], { relativeTo: this.route });
  }

}
